import {toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"

//響應機制的userinfo
const userInfoRef = toRef(useUserinfo())

const record1Api = {
    //查詢收到的名片收錄請求
    "getMemberworkByRecord1": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record1/getMemberworkByRecord1`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                updatedid: 0
            }
        }
    },
    //通過請求
    "assentRecord1": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record1/assentRecord1`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                mssqlno: null //token
            }
        }
    },
    //刪除請求
    "delRecord1": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record1/delRecord1`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //查詢自己發送的名片請求
    "getMyMemberworkByRecord1": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record1/getMyMemberworkByRecord1`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                updatedid: 0
            }
        }
    },
    //发送名片收录请求
    "sendRecord1": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}/record1/sendRecord1`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo2: null,  //要收录的名片id
                login: null,  //申请者的login
                addinfo3: 1,  //是否自动通过申请 0不自动通过 1自动通过
                companycode: null //申请者的companycode
            }
        }
    }
}

export default record1Api